import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CheckoutService } from "../../checkout/checkout.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "visualizar-contrato",
  templateUrl: "./visualizar-contrato.component.html",
  styleUrls: ["./visualizar-contrato.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class VisualizarContratoComponent implements OnInit, OnDestroy {
  @Input() pla_contrato: string;
  @Input() pla_nome: string;
  @Input() isPagamentoCartao: boolean = false;
  @Input() telefoneTitular: string = '';
  @Input() dadosVenda: any;

  token: string | undefined;
  captchaTouched: boolean = false;
  recaptchaTouched: boolean = false;
  inputTouched: boolean = false;

  submittedVenda: boolean = false;
  loading = [false];
  processandoVenda: boolean = false;

  mostrarValidacaoTelefone: boolean = false;
  telefoneParaValidar: string = '';
  telefoneValidado: boolean = false;
  codigoValidacaoTelefone: string = '';
  
  codigoValidacao: string = '';
  erroValidacao: boolean = false;
  mensagemErro: string = '';
  enviandoCodigo: boolean = false;
  
  tempoEsperaReenvio: number = 0;
  intervalTimer: ReturnType<typeof setInterval> | null = null;
  
  Math = Math;

  public form: FormGroup;

  get f() {
    return this.form.controls;
  }

  get recaptcha() {
    return this.form.get("recaptcha");
  }

  get captcha() {
    return this.form.get("captcha");
  }

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private checkoutService: CheckoutService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      acceptanceTerms: new FormControl(false, [Validators.requiredTrue]),
    });
  }

  // async onSubmit() {
  //   this.activeModal.close();
  // }

  onCaptchaVerify(token: string): void {
    this.token = token;

    // TODO: Remover temporariamente a validação por SMS
    // if(this.isPagamentoCartao) {
    //   this.mostrarValidacaoTelefone = true
    // };

    console.log(`Captcha Token [${token}] generated`);
  }

  onCaptchaExpired(response: any): void {
    this.token = undefined;
    console.log('Captcha expired', response);
  }

  onCaptchaError(error: any): void {
    this.token = undefined;
    console.error('Captcha error', error);
  }

  validarTelefoneObrigatorio() {
    if (!this.isPagamentoCartao) {
      return false;
    }    
    const codigoPreenchido = !!this.codigoValidacao?.trim();
    const desabilitarBotao = !codigoPreenchido || this.erroValidacao;
    return desabilitarBotao;
  }

  async onSubmit() {
    try {
      if (!this.token) {
        this.captchaTouched = true;
        this.recaptchaTouched = true;
        return;
      }

      if (!this.form.get("acceptanceTerms").value) {
        this.inputTouched = true;
        return;
      }
      this.processandoVenda = true;

      const dadosVenda = this.prepararDadosVenda();
      
      try {
        const resultado = await this.checkoutService.createVenda(dadosVenda);
        
        this.activeModal.close({ 
          token: this.token, 
          codigoValidacaoTelefone: this.codigoValidacao,
          sucesso: true,
          resultado: resultado
        });
        
      } catch (error: any) {
        if (error?.error?.message && error.error.message.startsWith('SMS_ENVIADO:')) {
          const [, telefone, mensagem] = error.error.message.split(':');
          this.telefoneParaValidar = telefone;
          this.mostrarValidacaoTelefone = true;
          this.toastr.info("Validação de Segurança", mensagem);
          return;
        }
        
        if (error?.error?.message && (
          error.error.message.includes('Código de validação incorreto') ||
          error.error.message.includes('Código já foi utilizado') ||
          error.error.message.includes('Código de validação expirado')
        )) {
          this.erroValidacao = true;
          this.mensagemErro = error.error.message;
          this.codigoValidacao = '';
          return;
        }
       
        
        this.toastr.error("Erro", error?.error?.message || error?.message || "Erro inesperado ao processar a venda.");
        throw error;
      }
      
    } catch (error) {
      console.log(error);
      this.activeModal.dismiss(error);
    } finally {
      this.processandoVenda = false;
    }
  }

  async onSubmitVenda() {
    try {
      if (!this.token) {
        this.recaptchaTouched = true;
        return;
      }

      this.form.patchValue({
        token_recaptcha: this.token,
      });
    } catch (error) {
      console.log(error);
    }
  }

  getUrlContract() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.pla_contrato);
  }

  prepararDadosVenda() {
    if (!this.dadosVenda) {
      console.error('Dados da venda não foram fornecidos ao modal');
      throw new Error('Dados da venda não disponíveis');
    }
    
    const dados = { ...this.dadosVenda };
    
    dados.token_recaptcha = this.token;
    
    if (this.codigoValidacao) {
      dados.codigo_validacao_telefone = this.codigoValidacao;
    }
    
    return dados;
  }

  async reenviarCodigo() {
    try {
      this.enviandoCodigo = true;
      this.erroValidacao = false;
      
      await this.checkoutService.reenviarCodigoValidacao(this.telefoneParaValidar);
      this.toastr.success("Código reenviado", "Um novo código foi enviado para seu telefone");
      
      this.iniciarContadorReenvio();
      
    } catch (error: any) {
      if (error?.error?.message && error.error.message.includes('Aguarde')) {
        const match = error.error.message.match(/Aguarde (\d+) segundos/);
        if (match) {
          const segundos = parseInt(match[1]);
          this.tempoEsperaReenvio = segundos;
          this.iniciarContadorReenvio();
          this.toastr.warning("Aguarde", error.error.message);
        }
      } else {
        this.toastr.error("Erro", error?.error?.message || "Não foi possível reenviar o código. Tente novamente.");
      }
    } finally {
      this.enviandoCodigo = false;
    }
  }

  iniciarContadorReenvio() {
    if (this.tempoEsperaReenvio <= 0) {
      this.tempoEsperaReenvio = 120;
    }
    
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
    
    this.intervalTimer = setInterval(() => {
      this.tempoEsperaReenvio--;
      
      if (this.tempoEsperaReenvio <= 0) {
        clearInterval(this.intervalTimer!);
        this.intervalTimer = null;
      }
    }, 1000);
  }

  ngOnDestroy() {
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
  }

}
